const dateTime = new Intl.DateTimeFormat('en-MY', {
  dateStyle: 'medium',
  timeStyle: 'short',
});

export function sessionTime(value: string): string {
  return dateTime.format(new Date(value));
}
